<template>
  <div class="dpv-lots-table table-component">
    <artisio-table :pagination="tableData.pagination" :sort="tableData.ordering" :items="tableData.rows"
                   :busy="tableData.loading" :fields="tableFields" show-toggle-columns
                   export-vuex-module-name="dpvLots" export-permission-name="view_auction"
                   :export-attributes="exportAttributes" :enable-simple-search="false"
                   @paramsChanged="getTableData" :extra-data="extraData"
                   @update-toggle-columns="updateToggleColumns" :enable-frontend-export="true"
                   @on-column-save="updateToggleColumns">
      <template slot="cell(dpv_no)" slot-scope="{item: dpvLot}">
        {{ dpvLot.dpv.dpv_no }}
      </template>
      <template slot="cell(sale_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.dpv.auction_number }}
      </template>
      <template slot="cell(lot_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.lot_number }}
      </template>
      <template slot="cell(receipt_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.receipt_number }}
      </template>
      <template slot="cell(stock_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.stock_number }}
      </template>
      <template slot="cell(lot_title)" slot-scope="{item: dpvLot}">
        {{ dpvLot.lot_title }}
      </template>
      <template slot="cell(hammer_price)" slot-scope="{item: dpvLot}">
        {{ dpvLot.hammer_price }}
      </template>
      <template slot="cell(buyer_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.dpv.buyer_number }}
      </template>
      <template slot="cell(buyer_full_name)" slot-scope="{item: dpvLot}">
        {{ dpvLot.dpv.buyer_full_name }}
      </template>
      <template slot="cell(invoice_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.dpv.invoice_number }}
      </template>
      <template slot="cell(credit_note_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.dpv.credit_note_number }}
      </template>
      <template slot="cell(seller_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.seller_number }}
      </template>
      <template slot="cell(seller_full_name)" slot-scope="{item: dpvLot}">
        {{ dpvLot.seller_full_name }}
      </template>
      <template slot="cell(settlement_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.settlement_number }}
      </template>
      <template slot="cell(debit_note_number)" slot-scope="{item: dpvLot}">
        {{ dpvLot.debit_note_number }}
      </template>
    </artisio-table>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import i18n from "@/shared/i18n";
  import {DPV_LOTS_TABLE_NAME} from "../constants";

  const {mapState, mapActions} = createNamespacedHelpers('dpv/lots');

  export default {
    name: "DpvLotsTable",
    components: {ArtisioTable},
    props: {
      exportAttributes: {
        type: Object,
        default: () => {
          return {
            dpv_no: i18n.t('DPV Number'),
            sale_number: i18n.t('Sale'),
            lot_number: i18n.t('Lot'),
            receipt_number: i18n.t('Receipt'),
            stock_number: i18n.t('Receipt / Item'),
            lot_title: i18n.t('Title'),
            hammer_price: i18n.t('Hammer Price'),
            buyer_number: i18n.t('Buyer Number'),
            buyer_full_name: i18n.t('Buyer'),
            invoice_number: i18n.t('Invoice'),
            credit_note_number: i18n.t('Associated Credit Note'),
            seller_number: i18n.t('Vendor Number'),
            seller_full_name: i18n.t('Vendor'),
            settlement_number: i18n.t('Settlement'),
            debit_note_number: i18n.t('Associated Debit Note'),
            progress: null
          }
        }
      }
    },
    computed: {
      ...mapState({
        tableData: state => state.tableData,
        toggleColumns: state => state.tableData.toggleColumns,
        dpvUuid: state => state.modal.dpvUuid
      }),
      tableFields() {
        return _.cloneDeep(this.toggleColumns.fields).filter(field => field.isVisible);
      },
      extraData() {
        return {
          ...this.toggleColumns,
          tableName: DPV_LOTS_TABLE_NAME
        }
      }
    },
    methods: {
      ...mapActions(['getTableData', 'updateToggleColumns'])
    },
    mounted() {
      this.getTableData();
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    .artisio-table {
      .dpv-details-title-col {
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
</style>
